module.exports = __webpack_public_path__ + "assets/img/btn-detail-9f41bbd0.png";